import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { Api } from 'src/smoothr-web-app-core/api/api';
import Order from 'src/smoothr-web-app-core/models/Order';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { AnalyticsService } from 'src/smoothr-web-app-core/services/analytics/analytics.service';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import { OrderUtils } from 'src/smoothr-web-app-core/utils/order-utils';
import { axiosErrorToMessage, numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-add-promocode-modal',
	templateUrl: './add-promocode-modal.component.html',
	styleUrls: ['./add-promocode-modal.component.scss'],
})
export class AddPromocodeModalComponent implements OnInit, OnDestroy {
	private onDestroy$ = new Subject<void>();
	public order: Order;
	public venue: Venue;
	public enterForm = new FormControl('');
	public promoError: string = '';
	public loading: boolean = false;
	constructor(
		private modalCtrl: ModalController,
		public translate: TranslateService,
		private repository: RepositoryService,
		private analytics: AnalyticsService
	) {}
	static async show(modalCtrl: ModalController, order: Order, venue: Venue): Promise<{ order: Order }> {
		const modal = await modalCtrl.create({
			cssClass: 'info-modal auto-height',
			component: AddPromocodeModalComponent,
			componentProps: {
				order,
				venue,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}
	ngOnInit() {
		this.enterForm.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(v => {
			this.promoError = '';
		});
	}
	ngOnDestroy(): void {
		this.onDestroy$.next();
	}
	public dismiss() {
		this.modalCtrl.dismiss();
	}

	async checkPromoCode() {
		if (!this.enterForm.value) {
			this.promoError = this.translate.instant('promo_code.not_valid');
			return;
		}
		this.loading = true;
		this.promoError = null;
		try {
			const promoCode = (
				await Api.getPromoCode({
					code: this.enterForm.value.trim(),
					venue: this.order.venue,
				})
			).data;
			promoCode.mov = +promoCode.mov;
			if (OrderUtils.orderTotalPrice(this.order, false, false) < promoCode.mov) {
				this.promoError = this.translate.instant('promo_code.mov_not_reached', {
					mov: numberToCurrency(promoCode.mov, this.order.currency),
				});
				this.loading = false;

				return;
			}
			try {
				try {
					const orderCopy = JSON.parse(JSON.stringify(this.order));
					orderCopy.promoCode = promoCode;
					orderCopy.userUid = this.repository.customer.uid;
					orderCopy.orderAt = null;
					await Api.applyPromoCode(orderCopy);
				} catch (e) {
					this.loading = false;

					this.promoError = axiosErrorToMessage(this.translate, e);
					return;
				}
				this.modalCtrl.dismiss({
					order: OrderUtils.applyPromo(this.translate, this.repository._venue, this.order, promoCode, this.analytics),
				});
				this.loading = false;
			} catch (e) {
				this.promoError = e;
				this.loading = false;
			}
		} catch (e) {
			this.loading = false;
			if (e.response.status === 404) {
				this.promoError = this.translate.instant('promo_code.not_valid');
				return;
			}
			this.promoError = axiosErrorToMessage(this.translate, e);
			return;
		}
	}
}
